/**
 * Personal Data Vault client — the consumer's identity is entered ONCE
 * into Altara and reused via consent across institutions.
 */
import axios from "axios";
import { getDeviceId } from "@/lib/drop-off-notifications";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/wallet/identity`;

export async function getIdentity() {
  const { data } = await axios.get(API, { params: { device_id: getDeviceId() } });
  return data;
}

export async function saveIdentity(payload) {
  const { data } = await axios.put(API, payload, { params: { device_id: getDeviceId() } });
  return data;
}

export async function verifyKyc(provider = null) {
  const { data } = await axios.post(`${API}/verify`, provider ? { provider } : {}, {
    params: { device_id: getDeviceId() },
  });
  return data;
}

export async function eraseIdentity() {
  const { data } = await axios.delete(API, { params: { device_id: getDeviceId() } });
  return data;
}

export const SA_PROVINCES = [
  { value: "eastern_cape",   label: "Eastern Cape" },
  { value: "free_state",     label: "Free State" },
  { value: "gauteng",        label: "Gauteng" },
  { value: "kwazulu_natal",  label: "KwaZulu-Natal" },
  { value: "limpopo",        label: "Limpopo" },
  { value: "mpumalanga",     label: "Mpumalanga" },
  { value: "north_west",     label: "North West" },
  { value: "northern_cape",  label: "Northern Cape" },
  { value: "western_cape",   label: "Western Cape" },
];

export const ID_DOC_TYPES = [
  { value: "sa_id",           label: "SA ID (13-digit)" },
  { value: "passport",        label: "Passport" },
  { value: "asylum_permit",   label: "Asylum permit" },
  { value: "refugee_permit",  label: "Refugee permit" },
];

export const KYC_STATUS_LABELS = {
  not_started: { label: "Not verified", tone: "slate" },
  pending:     { label: "Verifying…",   tone: "amber" },
  verified:    { label: "Verified",     tone: "emerald" },
  failed:      { label: "Verification failed", tone: "rose" },
  expired:     { label: "Expired — please re-verify", tone: "amber" },
  in_review:   { label: "Under manual review", tone: "amber" },
};
